<template>
  <div>
    <v-row>
      <v-col cols="12" :md="modalView ? 12 : 8" :offset-md="modalView ? 0 : 2" :lg="modalView ? 12 : 6" :offset-lg="modalView ? 0 : 3">
        <form @submit.prevent="save">
          <v-text-field
            v-model="form.name"
            ref="nameField"
            label="Naziv *"
          ></v-text-field>
          <FormErrors
            v-if="$v.form.$error && (!$v.form.name.required || !$v.form.name.unique)"
          >
            <FormErrorsLine v-if="!$v.form.name.required" text="Polje je obvezno" />
            <FormErrorsLine v-if="!$v.form.name.unique" text="Artikel z istim imenom že obstaja" />
          </FormErrors>
          <!-- <v-text-field
            v-model="form.description"
            label="Opis"
          ></v-text-field> -->
          <v-text-field
            v-model="form.price"
            @blur="parseFormPrice"
            label="Cena v evrih *"
          ></v-text-field>
          <FormErrors
            v-if="$v.form.$error && (!$v.form.price.required)"
          >
            <FormErrorsLine v-if="!$v.form.price.required" text="Polje je obvezno" />
          </FormErrors>
          <v-select
            :items="localGroups"
            item-text="name"
            item-value="id"
            v-model="form.group"
            label="Grupa *"
          >
            <v-tooltip
              top
              slot="append-outer"
            >
              <template v-slot:activator="{ on }">
                <v-btn icon small @click="showAddGroupModal = true" v-on="on">
                  <v-icon>
                    mdi-plus
                  </v-icon>
                </v-btn>
              </template>
              <span>Dodaj novo grupo</span>
            </v-tooltip>
          </v-select>
          <FormErrors
            v-if="$v.form.$error && (!$v.form.group.required)"
          >
            <FormErrorsLine v-if="!$v.form.group.required" text="Polje je obvezno" />
          </FormErrors>
          <v-select
            :items="localCategories"
            item-text="name"
            item-value="id"
            v-model="form.category"
            label="Skupina *"
          >
            <v-tooltip
              top
              slot="append-outer"
            >
              <template v-slot:activator="{ on }">
                <v-btn icon small @click="showAddCategoryModal = true" v-on="on">
                  <v-icon>
                    mdi-plus
                  </v-icon>
                </v-btn>
              </template>
              <span>Dodaj novo skupino</span>
            </v-tooltip>
          </v-select>
          <FormErrors
            v-if="$v.form.$error && (!$v.form.category.required)"
          >
            <FormErrorsLine v-if="!$v.form.category.required" text="Polje je obvezno" />
          </FormErrors>
          <v-select
            :items="measurementUnits"
            item-text="name"
            item-value="id"
            v-model="form.purchase_measurement_unit"
            label="Enota za nakup"
          ></v-select>
          <v-select
            :items="measurementUnits"
            item-text="name"
            item-value="id"
            v-model="form.sell_measurement_unit"
            label="Enota za prodajo"
          ></v-select>
          <v-row>
            <v-col cols="12" sm="6" lg="4" class="py-0">
              <v-checkbox
                hide-details
                color="#0F998E"
                v-model="form.is_visible"
                label="Se prodaja"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" md="4" class="py-0">
              <v-checkbox
                hide-details
                color="#0F998E"
                v-model="form.inventory_kept"
                label="Vodenje zaloge"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" md="4" class="py-0">
              <v-checkbox
                hide-details
                color="#0F998E"
                v-model="form.ask_for_price"
                label="Vprašaj za ceno"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" md="4" class="py-0">
              <v-checkbox
                hide-details
                color="#0F998E"
                v-model="form.ask_for_quantity"
                label="Vprašaj za količino"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" lg="4" class="py-0">
              <v-checkbox
                hide-details
                color="#0F998E"
                v-model="form.show_properties "
                label="Prikaži urejanje"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" md="4" class="py-0">
              <v-checkbox
                hide-details
                color="#0F998E"
                v-model="form.name_change_allowed"
                label="Ime se lahko spreminja"
              ></v-checkbox>
            </v-col>
          </v-row>
          <br>
          <v-btn v-if="!skrij" type="submit" class="float-right" :disabled="disabled">Shrani</v-btn>
          <v-btn v-if="!modalView && isNewArticle && !skrij" type="button" class="float-right mr-4" @click="saveAndRepeat" :disabled="disabled">Shrani in nov</v-btn>
          <v-btn v-if="!skrij" text type="button" class="float-right mr-4" @click="$emit('cancel')">Prekliči</v-btn>
          <div style="display: none;">
            {{spremenjenoIme}}
            {{spremenjenoInformacije}}
            {{spremenjenoCena}}
            {{spremenjenoGroup}}
            {{spremenjenoCategory}}
            {{spremenjenoEnotaNakupa}}
            {{spremenjenoEnotaProdaje}}
            {{spremenjenoVisible}}
            {{spremenjenoAskPrice}}
            {{spremenjenoAskQnt}}
            {{spremenjenoNameChange}}
            {{changedShowProperties}}
          </div>
        </form>
      </v-col>
    </v-row>
    <PopupAddCategory
      ref="addCategoryModal"
      v-model="showAddCategoryModal"
      @confirmed="addCategory"
    />
    <PopupAddGroup
      ref="addGroupModal"
      v-model="showAddGroupModal"
      @confirmed="addGroup"
    />
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import FormErrors from '@/components/FormErrors'
import FormErrorsLine from '@/components/FormErrorsLine'
import PopupAddCategory from '@/components/PopupAddCategory'
import PopupAddGroup from '@/components/PopupAddGroup'
import { parsePrice } from '@/utils/price'
import { mapActions } from 'vuex'
import { objectToArray } from '@/utils/object'
import { siMatch } from '@/utils/str'

export default {
  components: {
    FormErrors,
    FormErrorsLine,
    PopupAddCategory,
    PopupAddGroup
  },
  props: {
    article: {
      default: () => {},
      type: Object
    },
    modalView: {
      default: false,
      type: Boolean
    },
    groups: {
      required: true,
      type: Array
    },
    categories: {
      required: true,
      type: Array
    },
    articles: {
      required: true,
      type: Array
    },
    skrij: {
      required: false,
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      localStaraForm: null,
      localCategories: [],
      localGroups: [],
      showAddCategoryModal: false,
      showAddGroupModal: false,
      disabled: false,
      emptyForm: {
        name: '',
        description: '',
        price: '',
        group: null,
        category: null,
        sort_order: null,
        inventory_kept: false,
        purchase_measurement_unit: null,
        sell_measurement_unit: null,
        is_visible: true,
        ask_for_price: false,
        ask_for_quantity: false,
        name_change_allowed: false,
        show_properties: false,
      },
      form: {},
      dataFetched: false,
      razlog: null
    }
  },
  validations: {
    form: {
      name: {
        required,
        unique (val) {
          if (!val.length) return true
          const matchingArticle = this.articles.filter(article => siMatch({ str1: article.name, str2: val }))
          return (Array.isArray(matchingArticle) && matchingArticle.length === 0) || (!this.isNewArticle && matchingArticle[0].id === this.article.id)
        }
      },
      price: {
        required
      },
      group: {
        required
      },
      category: {
        required
      }
    }
  },
  computed: {
    measurementUnits () {
      const units = objectToArray(this.$store.state.measurementUnits.items)
      const sortedArr = units.reduce((acc, element) => {
        if (element.name === 'Por' || element.name === 'L' || element.name === 'Kos' || element.name === 'Kg') {
          return [element, ...acc]
        }
        return [...acc, element]
      }, [])
      return [ { id: null, name: 'Brez enote' }, ...sortedArr ]
    },
    isNewArticle () {
      return this.article ? Object.keys(this.article).length === 0 || !this.article.id : true
    },
    articleName () {
      return this.form.name
    },
    spremenjenoIme () {
      return this.localStaraForm ? this.form.name !== this.localStaraForm.name : false
    },
    spremenjenoInformacije () {
      return this.localStaraForm ? this.form.description !== this.localStaraForm.description : false
    },
    spremenjenoCena () {
      return this.localStaraForm ? this.form.price !== this.localStaraForm.price : false
    },
    spremenjenoGroup () {
      return this.localStaraForm ? this.form.group !== this.localStaraForm.group : false
    },
    spremenjenoCategory () {
      return this.localStaraForm ? this.form.category !== this.localStaraForm.category : false
    },
    spremenjenoEnotaNakupa () {
      return this.localStaraForm ? this.form.purchase_measurement_unit !== this.localStaraForm.purchase_measurement_unit : false
    },
    spremenjenoEnotaProdaje () {
      return this.localStaraForm ? this.form.sell_measurement_unit !== this.localStaraForm.sell_measurement_unit : false
    },
    spremenjenoVisible () {
      return this.localStaraForm ? this.form.is_visible !== this.localStaraForm.is_visible : false
    },
    spremenjenoAskPrice () {
      return this.localStaraForm ? this.form.ask_for_price !== this.localStaraForm.ask_for_price : false
    },
    spremenjenoAskQnt () {
      return this.localStaraForm ? this.form.ask_for_quantity !== this.localStaraForm.ask_for_quantity : false
    },
    spremenjenoNameChange () {
      return this.localStaraForm ? this.form.name_change_allowed !== this.localStaraForm.name_change_allowed : false
    },
    changedShowProperties () {
      return this.localStaraForm ? this.form.show_properties !== this.localStaraForm.show_properties : false
    }
  },
  methods: {
    ...mapActions('measurementUnits', { 'loadMeasurementUnits': 'loadItems' }),
    ...mapActions('categories', { createNewCategory: 'saveItem' }),
    ...mapActions('groups', { createNewGroup: 'saveItem' }),
    save () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        this.$emit('save', { data: this.form })
      }
    },
    saveAndRepeat () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        this.$emit('save', { data: this.form, repeat: true })
      }
    },
    saveAndRepeatClear () {
      setTimeout(() => {
        this.form.name = ''
        this.$refs.nameField.focus()
      }, 50)
    },
    clearForm () {
      this.form = { ...this.emptyForm }
    },
    cancel () {
      this.$emit('cancel')
    },
    toggleAutoSortOrder () {
      if (this.sortOrderCheckbox) {
        this.form.sort_order = null
      }
    },
    parseFormPrice () {
      this.form.price = parsePrice(this.form.price)
    },
    addCategory ({ data }) {
      this.createNewCategory({ ...data })
        .then(newCategory => {
          /* this.$notify({
            type: 'success',
            text: 'Podatki so bili uspešno shranjeni.'
          }) */
          this.showAddCategoryModal = false
          this.$refs.addCategoryModal.clearForm()
          this.localCategories.push(newCategory)
          this.form.category = newCategory.id
        })
    },
    addGroup ({ data }) {
      this.createNewGroup({ ...data })
        .then(newGroup => {
          /* this.$notify({
            type: 'success',
            text: 'Podatki so bili uspešno shranjeni.'
          }) */
          this.showAddGroupModal = false
          this.$refs.addGroupModal.clearForm()
          this.localGroups.push(newGroup)
          this.form.group = newGroup.id
        })
    }
  },
  mounted () {
    if (this.article) {
      this.$nextTick(() => {
        this.dataFetched = true
      })
    }
  },
  created () {
    this.localCategories = this.categories
    this.localGroups = this.groups
    this.form = { ...this.emptyForm }
    if (this.article) {
      this.form = { ...this.form, ...this.article, price: parsePrice(this.article.price) }
    }
    this.localStaraForm = { ...this.form }
    this.loadMeasurementUnits()
  },
  watch: {
    articleName (name, oldName) {
      if (name !== oldName) {
        this.disabled = false
      }
    },
    spremenjenoIme (sprememba) {
      const razlog = 'spremenjenoIme'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    },
    spremenjenoInformacije (sprememba) {
      const razlog = 'spremenjenoInfo'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    },
    spremenjenoCena (sprememba) {
      const razlog = 'spremenjenoCena'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    },
    spremenjenoGroup (sprememba) {
      const razlog = 'spremenjenoGroup'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    },
    spremenjenoCategory (sprememba) {
      const razlog = 'spremenjenoCategory'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    },
    spremenjenoEnotaNakupa (sprememba) {
      const razlog = 'enotaNakupa'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    },
    spremenjenoEnotaProdaje (sprememba) {
      const razlog = 'enotaProdaje'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    },
    spremenjenoVisible (sprememba) {
      const razlog = 'visible'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    },
    spremenjenoAskPrice (sprememba) {
      const razlog = 'askPrice'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    },
    spremenjenoAskQnt (sprememba) {
      const razlog = 'askquantity'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    },
    spremenjenoNameChange (sprememba) {
      const razlog = 'namechange'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    },
    changedShowProperties (sprememba) {
      const razlog = 'showpropertieschange'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    }
  }
}
</script>
